import { IActivityEntry } from "@hulanbv/platformapp";
import { CrudService } from "nest-utilities-client";
import { environment } from "../../constants/environment.constants";
import { httpService } from "../common/http.service";

class Service extends CrudService<IActivityEntry> {
  constructor() {
    super([environment.apiUrl, "activity-entries"].join("/"), httpService);
  }
}

export const activityEntriesService = new Service();
